var map = {
	"./ca.json": 61244,
	"./de.json": 19391,
	"./en.json": 62996,
	"./es.json": 63280,
	"./fr.json": 9716,
	"./gl.json": 81039,
	"./it.json": 34413,
	"./ru.json": 92769,
	"./whitelist_ca.json": 29382,
	"./whitelist_de.json": 43957,
	"./whitelist_en.json": 49849,
	"./whitelist_es.json": 36682,
	"./whitelist_fr.json": 28802,
	"./whitelist_gl.json": 64273,
	"./whitelist_it.json": 32539,
	"./whitelist_ru.json": 6891,
	"./whitelist_zh.json": 65796,
	"./zh.json": 67786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48423;